import React from 'react';
import PropTypes from 'prop-types';
import Select, { createFilter, components } from 'react-select';
import { Row, Col } from 'reactstrap';
import { FixedSizeList as List } from 'react-window';

import './SelectorHotel.css';

const listItemHeight = 40;

class MenuList extends React.Component {
  constructor(props) {
    super(props);
    this.listRef = undefined;
  }

  getFocusIndex = children => {
    const isArray = children instanceof Array;
    children = isArray ? children : [children];
    return Math.max(
      children.findIndex(({props: {isFocused} = {}} = {}) => {
        return isFocused === true;
      }),
      0,
    );
  }

  componentDidUpdate() {
    const { options, children } = this.props;

    if (options.length === 0) return;
    if (!children.length || children.length === 0) return;

    const currentIndex = this.getFocusIndex(children);
    this.listRef.scrollToItem(currentIndex);
  }

  render() {
    const {
      options,
      children,
      maxHeight,
      getValue
    } = this.props;

    const [value] = getValue();

    const initialOffset = options.indexOf(value) * listItemHeight;

    const noData = (options.length === 0 || !children.length || children.length === 0);

    if (noData) return <components.MenuList {...this.props}>{children}</components.MenuList>;

    return (
      <List
        ref={ref => { this.listRef = ref; }}
        height={Math.min(maxHeight, (children.length || 1) * listItemHeight)}
        itemCount={children.length}
        itemSize={listItemHeight}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}

class SelectorHotel extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dataTestLabel: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    userDefaultHotel: PropTypes.string,
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    placeHolder: PropTypes.string,
    stopPropagation: PropTypes.bool,
    dirtyEvent: PropTypes.func,
    handleSelectOption: PropTypes.func
  }

  static defaultProps = {
    title: '',
    dataTestLabel: '',
    options: [],
    userDefaultHotel: '',
    defaultValue: '',
    placeHolder: '',
    stopPropagation: false,
    dirtyEvent: () => {},
    handleSelectOption: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: this.props.options.filter(option => option.value === this.props.defaultValue),
      inEdition: false
    };
  }

  componentDidMount() {
    const { userDefaultHotel, defaultValue, options } = this.props;

    if (userDefaultHotel === '') return;

    if (options.length === 0) return;

    if (defaultValue !== '') return;

    const filteredHotel = options.find(
      hotelBean => (hotelBean.value === userDefaultHotel)
    );

    if (!filteredHotel) return;

    this.handleChange(filteredHotel);
  }

  setEditionMode = () => {
    this.setState({
      inEdition: true
    });
  }

  closeEditionMode = () => {
    this.setState({
      inEdition: false
    });
  }

  handleChange = (selectedOption) => {
    const { stopPropagation } = this.props;

    if (stopPropagation) {
      this.props.dirtyEvent();
      return;
    }

    this.setState({
      selectedOption
    }, () => {
      this.props.handleSelectOption(selectedOption.value);
    });
  }

  render() {
    const {
      title,
      dataTestLabel,
      placeHolder,
      options
    } = this.props;
    
    const { selectedOption, inEdition } = this.state;

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? '#FFF' : '#201E4B',
        background: state.isSelected ? '#201E4B' : ''
      })
    };

    const customContainerClass = `custom-select-component ${(inEdition) ? 'edition-mode' : ''}`;

    return (
      <Row className="selector-hotel-component auto-margin">
        {title !== '' &&
          <Col sm="12" className="component-title no-padding-left">{title}</Col>
        }
        <Col sm="12" className="component-form no-padding-left"  data-test-id={dataTestLabel}>
          <Select
            menuPlacement="auto"
            classNamePrefix="react-select-custom"
            className={customContainerClass}
            placeholder={placeHolder}
            value={selectedOption}
            options={options}
            filterOptions={createFilter({ ignoreAccents: false })}
            styles={customStyles}
            isSearchable={true}
            components={{ MenuList }}
            onChange={this.handleChange}
            onMenuOpen={this.setEditionMode}
            onMenuClose={this.closeEditionMode}
          />
        </Col>
      </Row>
    );
  }
};

export default SelectorHotel;
